import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.values.js";
import * as echarts from 'echarts';
import dayjs from 'dayjs';
export default {
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      id: "itemLogsLineChart-".concat(this.index, "-").concat(new Date().valueOf())
    };
  },
  mounted: function mounted() {
    this.init();
  },
  destroyed: function destroyed() {
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    init: function init() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      var chartDom = document.getElementById(this.id);
      this.myChart = echarts.init(chartDom);
      this.itemOptions = {};
      var _iterator = _createForOfIteratorHelper(this.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.valueType != 'Enums') {
            this.itemOptions[item.typeCode] = {
              name: item.typeName,
              type: 'line',
              connectNulls: true,
              // 连接缺失点
              data: []
            };
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(this.data),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          for (var key in this.itemOptions) {
            this.itemOptions[key].data.push([_item.ts, _item[key] || null]);
          }
        }

        // var chartData = {}
        // for(let item of this.data){
        //     if(!chartData[item.itemCode]){
        //         chartData[item.itemCode] = { 
        //             data:[]
        //             , name:item.itemName
        //             , type: "line" 
        //             , smooth: true
        //             , symbol: 'none'
        //         }
        //     }
        //     chartData[item.itemCode].data.unshift([ dayjs(item.ts).format('YYYY-MM-DD HH:mm'), Number(item.itemValue) ])
        //     // chartData[item.itemCode].data.unshift([ item.ts, Number(item.itemValue) ])
        // }
        // console.log('chartData',this.itemOptions)
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.option = {
        xAxis: {
          type: 'time',
          boundaryGap: false,
          show: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {
            show: true,
            color: 'rgba(255,255,255,0.65)',
            interval: 0,
            // 显示所有，重叠的会自动隐藏
            hideOverlap: true // 👈 自动隐藏重叠的标签
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          textStyle: {
            color: 'rgba(255,255,255,0.65)'
          },
          icon: 'rect',
          itemWidth: 6,
          itemHeight: 6,
          left: 'right'
        },
        color: ['#34C8FF', '#FF6363', '#7F43FF', '#FFE426', '#D57742'],
        grid: {
          left: 38,
          right: 10,
          bottom: 30,
          top: 30
        },
        series: Object.values(this.itemOptions)
      };
      this.option && this.myChart.setOption(this.option);
    }
  }
};